import { Navigate, Route, Routes } from "react-router-dom";
import PrivateRoutes from "../../core/routes/PrivateRoutes";
import { ListarClientes } from "../pages/ListarClientes";
import { ProgramasFidelidade } from "../pages/ProgramasFidelidade";
import { ConfiguracoesPedidoProvider } from "../../pedidos/contexts/ConfiguracoesPedidoContext";
import { Layout } from "../../core/components/Layout";

interface IClienteRoutesProps {
    autenticado: boolean;
}

export const ClienteRoutes = ({ autenticado }: IClienteRoutesProps) => {
    return (
        <ConfiguracoesPedidoProvider>
            <Routes>
                <Route element={
                    <Layout titulo="Clientes">
                        <PrivateRoutes
                            autenticado={autenticado}
                        />
                    </Layout>
                }>
                    <Route path="/listar" element={<ListarClientes />} />
                    <Route path="/programas-fidelidade" element={<ProgramasFidelidade />} />
                    <Route path="*" element={<Navigate to="/pagina-nao-encontrada" />} />
                </Route>
            </Routes>
        </ConfiguracoesPedidoProvider>
    );
}
